import { render, staticRenderFns } from "./AddonFeeForm.vue?vue&type=template&id=34e406c4&"
import script from "./AddonFeeForm.vue?vue&type=script&lang=js&"
export * from "./AddonFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports